module.exports = __webpack_public_path__ + "img/bxs-bowl-hot.35bf12e.svg";